import styled from 'styled-components'
import vars from '@/scss/variables.js'
import LogoSvg from './logo'

const { white, black, colorGrey9 } = vars

function handleSize(size) {
  return {
    small: {
      width: '66px',
      height: '12px',
    },
    medium: {
      width: '122.71px',
      height: '24px',
    },
    big: {
      width: '132.71px',
      height: '24px',
    },
  }[size]
}

function handleTheme(theme) {
  return {
    dark: {
      background: colorGrey9,
      color: white,
    },
    white: {
      background: white,
      color: black,
    },
  }[theme]
}

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const LogoContainer = styled.div`
  line-height: 0;
  svg {
    width: 100%;
    height: 100%;
  }
`

export const Logo = styled(LogoSvg).attrs(props => ({
  textColor: handleTheme(props.theme).color,
}))``

export const Content = styled.div`
  margin-left: auto;
`

export const InvertedBorder = styled.div`
  position: relative;
  height: 12px;
  width: 100%;

  &:before {
    content: '';
    position: absolute;
    background-color: transparent;
    left: -1px;
    bottom: -15px;
    height: 15px;
    width: 6px;
    border-top-left-radius: 6px;
  }
`

export const Container = styled.div`
  display: ${({ invertedBorder }) => invertedBorder && 'flex'};

  ${Wrapper} {
    background-color: ${({ theme }) =>
      theme === 'dark' && handleTheme(theme).background};
    padding: 6px 12px;
    border-radius: ${({ invertedBorder }) => invertedBorder && '4px 0 10px 0'};
  }

  ${LogoContainer} {
    width: ${({ size }) => handleSize(size).width};
    height: ${({ size }) => handleSize(size).height};
  }

  ${InvertedBorder} {
    background-color: ${({ theme }) => handleTheme(theme).background};

    &:before {
      box-shadow: 0 -6px 0 0 ${({ theme }) => handleTheme(theme).background};
    }
  }
`
